import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getDefinedTimePeriods } from 'gqlQueries/filterQueries';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

interface Props {
    onComplete: Function;
    onError?: Function;
}

function useFetchTimePeriod() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);
    const globalFilterConfig = getConfig('globalFilter', appConfig);
    const [
        fetchDefinedTimePeriods,
        { data: timePeriodData, loading: timePeriodDataLoading, error: timePeriodDataError },
    ] = useLazyQuery(getDefinedTimePeriods, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getDefinedTimePeriods } = payload;
            if (Array.isArray(getDefinedTimePeriods)) {
                const result: any = {};
                const timePeriodListMapping = globalFilterConfig.timePeriodListMapping;
                getDefinedTimePeriods.forEach((item) => {
                    if (item?.timeBucket in timePeriodListMapping) {
                        result[timePeriodListMapping[item?.timeBucket]] = item;
                    }
                });
                setData(result);
            }
        } catch (error: any) {
            console.error(errorMessage, error);
            setError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchDefinedTimePeriods: (variables: any) => {
            setLoading(true);
            fetchDefinedTimePeriods(variables);
        },
    };
}

export { useFetchTimePeriod };
